var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 30C11.1046 30 12 29.1046 12 28C12 26.8954 11.1046 26 10 26C8.89543 26 8 26.8954 8 28C8 29.1046 8.89543 30 10 30Z",
    fill: "#131F2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30C25.1046 30 26 29.1046 26 28C26 26.8954 25.1046 26 24 26C22.8954 26 22 26.8954 22 28C22 29.1046 22.8954 30 24 30Z",
    fill: "#131F2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 7.0002H5.82L5 2.8002C4.95325 2.57093 4.82758 2.36531 4.64486 2.21913C4.46214 2.07296 4.23395 1.99549 4 2.0002H0V4.0002H3.18L7 23.2002C7.04675 23.4295 7.17242 23.6351 7.35514 23.7813C7.53786 23.9275 7.76605 24.0049 8 24.0002H26V22.0002H8.82L8 18.0002H26C26.2312 18.0059 26.4571 17.9312 26.6395 17.789C26.8218 17.6468 26.9492 17.4458 27 17.2202L29 8.2202C29.0335 8.07183 29.0327 7.91776 28.9977 7.76974C28.9627 7.62171 28.8944 7.48362 28.798 7.36597C28.7015 7.24833 28.5795 7.15424 28.4413 7.09085C28.303 7.02747 28.1521 6.99647 28 7.0002ZM25.2 16.0002H7.62L6.22 9.0002H26.75L25.2 16.0002Z",
    fill: "#131F2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.a3b04a11f98bc6d0b89dee435125a9a8.svg";
export { ForwardRef as ReactComponent };